module.exports = __webpack_public_path__ + "static/media/about.41aabab3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/pages/menu/about.jpg
// module id = 147
// module chunks = 0